export enum PROFILE_ACTION {
  PROFILE = "Profile",
  CHANGE_PASSWORD="ChangePassword",
  ACCOUNT = "Account",
  ENABLE2FA = 'Enable 2FA',
  LOGOUT = "Logout",
}
